import { Component, OnInit } from '@angular/core';
import { I18ns } from '../../../utils/i18n/I18n';
import { NewTheme, Theme } from '../../../data/theme.model';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiService } from '../../../data/api.service';
import { MsgService } from '../../../utils/message/msg.service';
import { tap } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';
import { flagList } from '../../../data/flags';

@Component({
  selector: 'app-add-theme',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgIf, NgFor, RouterLink],
  templateUrl: './add-theme.component.html',
  styleUrl: './add-theme.component.scss',
})
export class AddThemeComponent implements OnInit {
  URL = environment.url;
  I18ns = I18ns;
  theme: NewTheme = {} as NewTheme;
  form: FormGroup;
  showForm = true;
  createdTheme?: Theme;
  showLangs = false;
  protected readonly flagList = flagList;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly api: ApiService,
    private readonly msg: MsgService,
  ) {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(32)]],
      email: ['', [Validators.required, Validators.email]],
      words: ['', Validators.required],
      lang: '',
      comments: '',
    });
  }

  ngOnInit() {}

  save() {
    let words = this.cleanUpText(this.form.value.words);
    const count = (words.match(/,/g) || []).length;

    if (count < 10) {
      this.msg.add({
        message: I18ns.addTheme.tooFewWords,
        severity: 'error',
      });
      return;
    }
    const theme = {
      name: this.form.value.name.replace(/[^A-zÀ-ÿ\d\s]/gi, ''),
      email: this.form.value.email,
      comments: this.form.value.comments.replace(/[^A-zÀ-ÿ\d\s]/gi, ''),
      words,
      lang: this.form.value.lang,
    } as NewTheme;

    this.api
      .createTheme(theme)
      .pipe(
        tap((res) => {
          this.createdTheme = res;
          this.showForm = false;
          window.scrollTo(0, 0);
        }),
      )
      .subscribe();
  }

  cleanUpText(text: string) {
    let words = text.replaceAll(' ', '').toLowerCase();

    const needle = words.includes('\r\n')
      ? '\r\n'
      : words.includes('\r')
        ? '\r'
        : words.includes('\n')
          ? '\n'
          : '';

    if (needle !== '') {
      words = words.replaceAll(needle, ',');
    }

    words = words
      .split(',')
      .filter((x) => !!x && x.length < 10)
      .join(',');

    // Special characters
    words = words.normalize('NFD').replace(/\p{Diacritic}/gu, '');
    words = words.replace(/\u0142/g, 'l');

    words = words.replace(/[^a-z,]/gi, '');

    return words;
  }

  copyLink() {
    navigator.clipboard.writeText(this.URL + '/k/' + this.createdTheme?.id).then(() => {
      this.msg.add({
        message: 'Copied to clipboard',
        severity: 'success',
        sticky: false,
        life: 1000,
      });
    });
  }

  pickLang(lang?: any) {
    this.form.controls['lang'].setValue(lang ? lang.tag : 'World');
  }
}
